import { observer } from 'mobx-react-lite';
import styles from './GlobalSpinner.module.css';
import { useStore } from '../../../../hooks/useStore';
import { PulseLoader } from 'react-spinners';

export const GlobalSpinner = observer(() => {
  const { uiStore } = useStore();

  if (!uiStore.isLoading) return null;

  return (
    <div className={styles.overlay}>
      <PulseLoader color="#a2d9ce" loading={true} size={30} />
    </div>
  );
});
